import { Box, Text } from '@opendoor/bricks-next';
import { Link } from '@opendoor/bricks/core';

import { EntryComponent } from 'cms/entries/entries';

import { IComponentSimpleCta } from '../../declarations/contentful';
import { EmbeddedEntryWrapper } from './EmbeddedEntryWrapper';

const renderSimpleCTA = (entry: IComponentSimpleCta) => {
  const { fields } = entry;
  return (
    <EmbeddedEntryWrapper alignment="text">
      <Box
        padding="$10x"
        alignItems={'center'}
        backgroundColor="$backgroundTertiary"
        borderRadius="$10x"
        flexDirection={'column'}
      >
        {fields.headline && (
          <Text
            tag="h5"
            typography="$subheaderSmall"
            fontWeight="bold"
            textAlign="center"
            margin={0}
            color="$contentPrimary"
          >
            {fields.headline}
          </Text>
        )}
        {fields.description && (
          <Text
            tag="p"
            textAlign="center"
            marginVertical="$5x"
            typography="$bodyMedium"
            $largerThanXS={{ typography: '$bodyLarge' }}
            color="$contentTertiary"
          >
            {fields.description}
          </Text>
        )}
        {fields.ctaLink && fields.ctaText && (
          <Link
            href={fields.ctaLink}
            target="_blank"
            variant="primary-button"
            aria-label="cta-link"
            analyticsName={'simple-cta-download-link'}
            width="auto"
          >
            {fields.ctaText}
          </Link>
        )}
      </Box>
    </EmbeddedEntryWrapper>
  );
};

const SimpleCTA: EntryComponent<IComponentSimpleCta> = {
  render: renderSimpleCTA,
};

export default SimpleCTA;
